import { useEffect } from "react";
import { Helmet } from 'react-helmet-async'
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from '@/contexts/auth-context'

const CONVEX_SITE_URL = import.meta.env.VITE_CONVEX_URL?.replace(
  ".cloud",
  ".site"
) || "https://industrious-panda-719.convex.site";

export default function UpgradePage() {
  const [searchParams] = useSearchParams();
  const project = searchParams.get("project");
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (!isAuthenticated) {
      const returnPath = `/upgrade${project ? `?project=${project}` : ''}`;
      navigate(`/login?from=${encodeURIComponent(returnPath)}`, { replace: true });
      return;
    }
    if (project) {
      window.location.href = `${CONVEX_SITE_URL}/api/stripe/checkout?workflowId=${project}&plan=pro`;
    }
  }, [project, isAuthenticated, isLoading, navigate]);

  if (!project) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Helmet>
          <title>Upgrade - Footage</title>
          <meta name="description" content="Upgrade your Footage plan." />
        </Helmet>
        <p className="text-muted-foreground">Redirecting to upgrade...</p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <Helmet>
        <title>Upgrade - Footage</title>
      </Helmet>
      <p className="text-muted-foreground">Redirecting to checkout...</p>
    </div>
  );
}
